export const weekColumnRegex = /^w\d{2}$/;
